var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.qr.length)?_c('b-img',{staticClass:"qr-image",attrs:{"src":_vm.qr}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }